export const ROOT = 'HtmlComponent';
export const IFRAME_COMPONENT = 'iframeComponent';
export const TOOLBAR_BUTTON_EDIT_HTML = 'baseToolbarButton_edit';
export const EDIT_PANEL = 'htmlEditPanel';
export const EDIT_PANEL_RADIO_GROUP = 'htmlEditPanel_htmlRadioGroup';
export const EDIT_PANEL_RADIO_HTML = 'htmlEditPanel_radioHtml';
export const EDIT_PANEL_RADIO_URL = 'htmlEditPanel_radioUrl';
export const EDIT_PANEL_HTML_INPUT = 'htmlEditPanel_htmlInput';
export const EDIT_PANEL_URL_INPUT = 'htmlEditPanel_urlInput';
export const EDIT_PANEL_CANCEL_BUTTON = 'htmlEditPanel_Cancel';
export const EDIT_PANEL_UPDATE_BUTTON = 'htmlEditPanel_Update';
